import * as ScheduleActions from '@Actions/schedules.actions';
import { put, retry, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { GetSchedulesParams, Schedule } from '@innovyze/stylovyze';
import { getTenantSchedulesService } from '@Services/schedules';

function* getTenantSchedulesSaga(action: PayloadAction<GetSchedulesParams>) {
	try {
		const response: AxiosResponse<Schedule[]> = yield retry(
			3,
			1500,
			getTenantSchedulesService,
			action.payload,
		);
		yield put(ScheduleActions.getTenantSchedulesResolved(response.data));
	} catch {
		yield put(ScheduleActions.getTenantSchedulesResolved([]));
	}
}

function* watchGetTenantSchedules() {
	yield takeLatest(
		ScheduleActions.getTenantSchedules,
		getTenantSchedulesSaga,
	);
}

export default [watchGetTenantSchedules()];
